export function textReveal() {
    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll(".text-reveal").forEach(element => {

        // Split eerst in regels
        const splitLines = new SplitText(element, {
            type: "lines",
            linesClass: "line"
        });

        // Daarna woorden binnen die regels
        const splitWords = new SplitText(splitLines.lines, {
            type: "words",
            wordsClass: "word"
        });

        gsap.from(splitWords.words, {
            opacity: 0,
            yPercent: 100,
            duration: 0.9,
            ease: "power2.out",
            stagger: 0.02,
            scrollTrigger: {
                trigger: element,
                start: "top 90%",
                toggleActions: "play none none none"
            }
        });
    });
}
